import {createReducer, on} from '@ngrx/store';
import {MitarbeiterDialogState} from '../states/mitarbeiter-dialog.state';
import {MitarbeiterDialogActions} from '../actions/mitarbeiter-dialog.actions';

export const initialMitarbeiterDialogState: MitarbeiterDialogState = {
  isOpen: false,
};

export const mitarbeiterDialogReducer = createReducer(
  initialMitarbeiterDialogState,
  on(MitarbeiterDialogActions.open, (state, {inhaberId, mitarbeiter}) => ({
    ...state,
    isOpen: true,
    inhaberId,
    mitarbeiter,
  })),
  on(MitarbeiterDialogActions.close, state => ({
    ...state,
    isOpen: false,
  })),
);
